module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('h2', {
    staticClass: "CH1_Chapter_title_1 ParaOverride-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ACK")])]), _vm._v(" "), _c('p', {
    staticClass: "HT2"
  }, [_vm._v("WIDOW")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71876542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RR0208.vue
// module id = 63
// module chunks = 0